// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloseCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PCloseCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloseCircleOutlined = function PCloseCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloseCircleOutlinedSvg
  }));
};

PCloseCircleOutlined.displayName = 'PCloseCircleOutlined';
export default React.forwardRef(PCloseCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloseCircleOutlined.js
// module id = 3288
// module chunks = 0